
import NavigationComponent from "../../navigation/navigation.component";
import { Background, Gradient, OppGradient, Header1, Paragraph, PData, ProjDeets, OppProjDeets, Alinks} from "./responsive-web.styles";

const ResponsiveWeb = () => {
    return(
        <Background>
            <NavigationComponent></NavigationComponent>
            <Gradient></Gradient>
            <ProjDeets>
            <Header1>Survey Form</Header1>
            
            <Paragraph>This is the first certification project the Free Code Camp Responsive Web Design Certification. 
            You can view this project on <Alinks href="https://codepen.io/BrieAnnaAllen/full/JjZNmYV">codepen.</Alinks></Paragraph>
            
                <PData>
                    <strong>Project Type:</strong> Website <br/>
                    <strong>Date Completed:</strong> September 2022<br/>
                    <strong>Skills Used:</strong> HTML, CSS, Codepen, Visual Studio Code, Github Desktop</PData>
            </ProjDeets>
        
            <OppProjDeets>
                <OppGradient></OppGradient>
            <Header1>Tribute Page</Header1>
            
            <Paragraph>This is the second certification project the Free Code Camp Responsive Web Design Certification. 
            You can view this project on <Alinks href="https://codepen.io/BrieAnnaAllen/full/rNKmqLq">codepen.</Alinks></Paragraph>
            
                <PData>
                    <strong>Project Type:</strong> Website <br/>
                    <strong>Date Completed:</strong> October 2022<br/>
                    <strong>Skills Used:</strong> HTML, CSS, Codepen, Visual Studio Code, Github Desktop</PData>
            </OppProjDeets>
            <Gradient></Gradient>
            <ProjDeets>
            <Header1>"Technical Documentation"</Header1>
            
            <Paragraph>This is the third certification project the Free Code Camp Responsive Web Design Certification. 
            You can view this project on <Alinks href="https://codepen.io/BrieAnnaAllen/full/NWzjORv">codepen.</Alinks></Paragraph>
            
                <PData>
                    <strong>Project Type:</strong> Website <br/>
                    <strong>Date Completed:</strong> October 2022<br/>
                    <strong>Skills Used:</strong> HTML, CSS, Codepen, Visual Studio Code, Github Desktop</PData>
            </ProjDeets>
            
            <OppGradient></OppGradient>

            <OppProjDeets>
            <Header1>Product Landing Page</Header1>
            
            <Paragraph>This is the forth certification project the Free Code Camp Responsive Web Design Certification. 
            You can view this project on <Alinks href="https://codepen.io/BrieAnnaAllen/full/XWYRxjo">codepen.</Alinks></Paragraph>
            
                <PData>
                    <strong>Project Type:</strong> Website <br/>
                    <strong>Date Completed:</strong> October 2022<br/>
                    <strong>Skills Used:</strong> HTML, CSS, Codepen, Visual Studio Code, Github Desktop</PData>
            </OppProjDeets>

            <Gradient></Gradient>

            <ProjDeets>
            <Header1>Portfolio Website</Header1>
            
            <Paragraph>This is the fifth certification project the Free Code Camp Responsive Web Design Certification. 
            You can view this project on <Alinks href="https://codepen.io/BrieAnnaAllen/full/GRGaoVq">codepen.</Alinks></Paragraph>
            
                <PData>
                    <strong>Project Type:</strong> Website <br/>
                    <strong>Date Completed:</strong> November 2022<br/>
                    <strong>Skills Used:</strong> HTML, CSS, Codepen, Visual Studio Code, Github Desktop</PData>
            </ProjDeets>
            <OppGradient></OppGradient>
        </Background>
    )
}

export default ResponsiveWeb;